import * as Yup from "yup";
import { FmulinjeKursist } from "../../../interfaces/schema";
import InputItem from "../../../components/formcontrols/InputItem";

export const cancelLinjeKursistForm = (
  fmulinjeId: string,
  kursist: FmulinjeKursist,
): FormConfig<AfmeldFmulinjeKursistDTO> => {
  const get = `fmulinje/${fmulinjeId}/kursister/${kursist.id}`;
  const postQuery = `fmulinje/${fmulinjeId}/wizards/afmeldfmulinjekursist/${kursist.id}`;
  return {
    title: "kursist",
    get,
    form: [
      {
        component: "custom",
        label: "Navn",
        id: "navn",
        customComponent: () => (
          <InputItem
            id="navn"
            label="Navn"
            setValue={() => {}}
            disabled={true}
            value={`${kursist.person.fornavne} ${kursist.person.efternavn}`}
          />
        ),
      },
      {
        component: "textinput",
        id: "afmeldingsGebyr",
        initialValue: "",
        label: "Afmeldingsgebyr",
        placeholder: "0",
        isRequired: true,
      },
    ],
    validationSchema: Yup.object({
      afmeldingsGebyr: Yup.number().required("Afmeldingsgebyr skal være sat"),
    }),
    post: (body) => {
      const kursusPersonIdsTilKreditering = kursist.person.kursusPerson
        .filter((kp) => kp.hold.fmulinje?.id === fmulinjeId)
        .map((kp) => kp.id);

      return {
        query: postQuery,
        body: {
          ...body,
          kursusPersonIdsTilKreditering,
        },
      };
    },
  };
};

interface AfmeldFmulinjeKursistDTO {
  afmeldingsGebyr: number;
  kursusPersonIdsTilKreditering: string[];
}
